import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f1b7a9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { colspan: "10" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "费用信息", -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { colspan: "10" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "成本信息", -1))
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { colspan: "10" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "业务员结算价", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_miezz_button = _resolveComponent("miezz-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.hideCosts)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
          _createElementVNode("td", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_miezz_page_list, {
              modelValue: _ctx.listCosts,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listCosts) = $event)),
              onHandleRowButtonClick: _ctx.handleCostRowButtonClick
            }, {
              column: _withCtx(({ model, row, index }) => [
                (model.Prop == 'CostId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: `Costs[${index}].${model.Prop}`,
                      rules: _ctx.rules.CostId,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_select, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          label: row.CostLabel,
                          "onUpdate:label": ($event: any) => ((row.CostLabel) = $event),
                          options: _ctx.costs
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'CurrencySystemId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      prop: `Costs[${index}].${model.Prop}`,
                      rules: _ctx.rules.CurrencySystemId,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_select, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          label: row.CurrencySystemLabel,
                          "onUpdate:label": ($event: any) => ((row.CurrencySystemLabel) = $event),
                          options: _ctx.currencySystems
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'UnitPrice')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      prop: `Costs[${index}].${model.Prop}`,
                      rules: _ctx.rules.UnitPrice,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          pattern: "[0-9.-]",
                          number: true,
                          numberFixed: 2,
                          onHandleBlur: ($event: any) => (_ctx.handleCalcCostTotalPrice(index))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'TaxRate')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 3,
                      prop: `Costs[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          pattern: "[0-9.]",
                          number: true,
                          numberFixed: 2,
                          onHandleBlur: ($event: any) => (_ctx.handleCalcCostTotalPrice(index))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'FirstChargingUnitId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 4,
                      prop: `Costs[${index}].${model.Prop}`,
                      rules: _ctx.rules.FirstChargingUnitId,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_select, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          label: row.FirstChargingUnitLabel,
                          "onUpdate:label": ($event: any) => ((row.FirstChargingUnitLabel) = $event),
                          options: _ctx.transportChargeUnits
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'FirstChargingNumber')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 5,
                      prop: `Costs[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          pattern: "[0-9.-]",
                          number: true,
                          numberFixed: 2,
                          disabled: !row.FirstChargingUnitId,
                          onHandleBlur: ($event: any) => (_ctx.handleCalcCostTotalPrice(index))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onHandleBlur"])
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'SecondChargingUnitId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 6,
                      prop: `Costs[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_select, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          label: row.SecondChargingUnitLabel,
                          "onUpdate:label": ($event: any) => ((row.SecondChargingUnitLabel) = $event),
                          options: _ctx.transportChargeUnits
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options"])
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'SecondChargingNumber')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 7,
                      prop: `Costs[${index}]`,
                      rules: _ctx.rules.CostSecondChargingNumber,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          pattern: "[0-9.-]",
                          number: true,
                          numberFixed: 2,
                          disabled: !row.SecondChargingUnitId,
                          onHandleBlur: ($event: any) => (_ctx.handleCalcCostTotalPrice(index))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onHandleBlur"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'TaxAmount')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 8,
                      prop: `Costs[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.TaxAmount), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'TotalPrice')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 9,
                      prop: `Costs[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.TotalPrice), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'Remark')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 10,
                      prop: `Costs[${index}].${model.Prop}`,
                      rules: _ctx.rules.Remark,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          type: "textarea",
                          trim: false
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "onHandleRowButtonClick"]),
            _createVNode(_component_miezz_button, {
              style: {"color":"rgb(254, 153, 91)"},
              model: _ctx.btnAddCost,
              onHandleClick: _ctx.handleClick
            }, null, 8, ["model", "onHandleClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSupplierCosts)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
          _createElementVNode("td", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_miezz_page_list, {
              modelValue: _ctx.listSupplierCosts,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listSupplierCosts) = $event)),
              onHandleRowButtonClick: _ctx.handleCostRowButtonClick
            }, {
              column: _withCtx(({ model, row, index }) => [
                (model.Prop == 'PreSupplierLabel')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: `SupplierCosts[${index}]`,
                      rules: _ctx.rules.PreSupplierLabel,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          fetchSuggestions: (arg1, arg2) => _ctx.filterSuppliersMathod(arg1, arg2, row)
              ,
                          triggerOnFocus: true,
                          valueKey: "Label"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "fetchSuggestions"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'CostId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      prop: `SupplierCosts[${index}].${model.Prop}`,
                      rules: _ctx.rules.CostId,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_select, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          label: row.CostLabel,
                          "onUpdate:label": ($event: any) => ((row.CostLabel) = $event),
                          options: _ctx.costs
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'CurrencySystemId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      prop: `SupplierCosts[${index}].${model.Prop}`,
                      rules: _ctx.rules.CurrencySystemId,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_select, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          label: row.CurrencySystemLabel,
                          "onUpdate:label": ($event: any) => ((row.CurrencySystemLabel) = $event),
                          options: _ctx.currencySystems
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'UnitPrice')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 3,
                      prop: `SupplierCosts[${index}].${model.Prop}`,
                      rules: _ctx.rules.UnitPrice,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          pattern: "[0-9.-]",
                          number: true,
                          numberFixed: 2,
                          onHandleBlur: ($event: any) => (_ctx.handleCalcSupplierCostTotalPrice(index))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'TaxRate')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 4,
                      prop: `SupplierCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          pattern: "[0-9.]",
                          number: true,
                          numberFixed: 2,
                          onHandleBlur: ($event: any) => (_ctx.handleCalcSupplierCostTotalPrice(index))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'FirstChargingUnitId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 5,
                      prop: `SupplierCosts[${index}].${model.Prop}`,
                      rules: _ctx.rules.FirstChargingUnitId,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_select, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          label: row.FirstChargingUnitLabel,
                          "onUpdate:label": ($event: any) => ((row.FirstChargingUnitLabel) = $event),
                          options: _ctx.transportChargeUnits
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'FirstChargingNumber')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 6,
                      prop: `SupplierCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          pattern: "[0-9.-]",
                          number: true,
                          numberFixed: 2,
                          disabled: !row.FirstChargingUnitId,
                          onHandleBlur: ($event: any) => (_ctx.handleCalcSupplierCostTotalPrice(index))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onHandleBlur"])
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'SecondChargingUnitId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 7,
                      prop: `SupplierCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_select, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          label: row.SecondChargingUnitLabel,
                          "onUpdate:label": ($event: any) => ((row.SecondChargingUnitLabel) = $event),
                          options: _ctx.transportChargeUnits
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options"])
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'SecondChargingNumber')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 8,
                      prop: `SupplierCosts[${index}]`,
                      rules: _ctx.rules.CostSecondChargingNumber,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          pattern: "[0-9.-]",
                          number: true,
                          numberFixed: 2,
                          disabled: !row.SecondChargingUnitId,
                          onHandleBlur: ($event: any) => (_ctx.handleCalcSupplierCostTotalPrice(index))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onHandleBlur"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'TaxAmount')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 9,
                      prop: `SupplierCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.TaxAmount), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'TotalPrice')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 10,
                      prop: `SupplierCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.TotalPrice), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'Remark')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 11,
                      prop: `SupplierCosts[${index}].${model.Prop}`,
                      rules: _ctx.rules.Remark,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          type: "textarea",
                          trim: false
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "onHandleRowButtonClick"]),
            _createVNode(_component_miezz_button, {
              style: {"color":"rgb(254, 153, 91)"},
              model: _ctx.btnAddSupplierCost,
              onHandleClick: _ctx.handleClick
            }, null, 8, ["model", "onHandleClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSettlementCosts)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
          _createElementVNode("td", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_miezz_page_list, {
              modelValue: _ctx.listSettlementCosts,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listSettlementCosts) = $event)),
              onHandleRowButtonClick: _ctx.handleCostRowButtonClick
            }, {
              column: _withCtx(({ model, row, index }) => [
                (model.Prop == 'CostId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: `SettlementCosts[${index}].${model.Prop}`,
                      rules: _ctx.rules.CostId,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_select, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          label: row.CostLabel,
                          "onUpdate:label": ($event: any) => ((row.CostLabel) = $event),
                          options: _ctx.costs
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'CurrencySystemId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      prop: `SettlementCosts[${index}].${model.Prop}`,
                      rules: _ctx.rules.CurrencySystemId,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_select, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          label: row.CurrencySystemLabel,
                          "onUpdate:label": ($event: any) => ((row.CurrencySystemLabel) = $event),
                          options: _ctx.currencySystems
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'UnitPrice')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      prop: `SettlementCosts[${index}].${model.Prop}`,
                      rules: _ctx.rules.UnitPrice,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          pattern: "[0-9.-]",
                          number: true,
                          numberFixed: 2,
                          onHandleBlur: ($event: any) => (_ctx.handleCalcSettlementCostTotalPrice(index))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'TaxRate')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 3,
                      prop: `SettlementCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          pattern: "[0-9.]",
                          number: true,
                          numberFixed: 2,
                          onHandleBlur: ($event: any) => (_ctx.handleCalcSettlementCostTotalPrice(index))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'FirstChargingUnitId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 4,
                      prop: `SettlementCosts[${index}].${model.Prop}`,
                      rules: _ctx.rules.FirstChargingUnitId,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_select, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          label: row.FirstChargingUnitLabel,
                          "onUpdate:label": ($event: any) => ((row.FirstChargingUnitLabel) = $event),
                          options: _ctx.transportChargeUnits
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'FirstChargingNumber')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 5,
                      prop: `SettlementCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          pattern: "[0-9.-]",
                          number: true,
                          numberFixed: 2,
                          disabled: !row.FirstChargingUnitId,
                          onHandleBlur: ($event: any) => (_ctx.handleCalcSettlementCostTotalPrice(index))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onHandleBlur"])
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'SecondChargingUnitId')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 6,
                      prop: `SettlementCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_select, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          label: row.SecondChargingUnitLabel,
                          "onUpdate:label": ($event: any) => ((row.SecondChargingUnitLabel) = $event),
                          options: _ctx.transportChargeUnits
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options"])
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'SecondChargingNumber')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 7,
                      prop: `SettlementCosts[${index}]`,
                      rules: _ctx.rules.CostSecondChargingNumber,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          pattern: "[0-9.-]",
                          number: true,
                          numberFixed: 2,
                          disabled: !row.SecondChargingUnitId,
                          onHandleBlur: ($event: any) => (_ctx.handleCalcSettlementCostTotalPrice(index))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onHandleBlur"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'TaxAmount')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 8,
                      prop: `SettlementCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.TaxAmount), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'TotalPrice')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 9,
                      prop: `SettlementCosts[${index}].${model.Prop}`,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.TotalPrice), 1)
                      ]),
                      _: 2
                    }, 1032, ["prop"]))
                  : _createCommentVNode("", true),
                (model.Prop == 'Remark')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 10,
                      prop: `SettlementCosts[${index}].${model.Prop}`,
                      rules: _ctx.rules.Remark,
                      "label-width": "0px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: row[model.Prop],
                          "onUpdate:modelValue": ($event: any) => ((row[model.Prop]) = $event),
                          type: "textarea",
                          trim: false
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "onHandleRowButtonClick"]),
            _createVNode(_component_miezz_button, {
              style: {"color":"rgb(254, 153, 91)"},
              model: _ctx.btnAddSettlementCost,
              onHandleClick: _ctx.handleClick
            }, null, 8, ["model", "onHandleClick"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}